fx.ns("shared.stage", class FrameAction extends shared.stage.Frame {

    constructor(model, options)
    {
        super(model);

        this.assets = fx.get("assets");
        this._anchorSize = 25;
        this._scale = 1;   

        this.options = Object.assign(this.defaults, options || {});
    }

    get defaults()
	{
		return  { anchors : true, rotate : true, innerDrag : true, infoBubble : true};
	}
    
    get anchorSize()
    {
        return this._anchorSize;
    }

    set anchorSize(val)
    {
        this._anchorSize = val;
    }

    get scale()
    {
        return this._scale;
    }

    get currentArea()
    {
        return this._currentArea;
    }

    set currentArea(val)
    {
         // We listen on parent, because we need to detect when mouse is over anchor
         // and anchor is not part or currentArea, but of common parent
         // no need to listen on Window, to broad.
        if (this._currentArea)
            this.off("mousemove", this.onMouseMove, this._currentArea.parent);


        this._currentArea = val;

        if (this._currentArea)
        {
            this.on("mousemove", this.onMouseMove, this._currentArea.parent);
            this._scale = fx.graphics.getScale(this._currentArea.node);

            this.attr("size", this._currentArea.attr("size"));
        }
    }

    get currentElement()
    {
        return super.currentElement;
    }

    set currentElement(val)
    {
        if (this.currentElement)
            this.currentElement.anchorsActive = false;

        super.currentElement = val;
    }

    get infoBubble()
    {
        if (!this._infoBubble)
        {
            this._infoBubble = new shared.stage.InfoBubble(this);
            this._infoBubble.visibleAtStart = false;
            this.addChild( this._infoBubble );
        }

        return this._infoBubble;
    }

    onReady()
    {
        super.onReady();

        if (this.options.rotate)
            this.anchorRotate = this.find(".anchor.rotate");

        if (this.options.anchors)
        {
            this.anchorTopLeft = this.find(".anchor.top-left");
            this.anchorTopRight = this.find(".anchor.top-right");
            this.anchorBottomRight = this.find(".anchor.bottom-right");
            this.anchorBottomLeft = this.find(".anchor.bottom-left");
            this.anchorMiddleLeft = this.find(".anchor.middle-left");
            this.anchorMiddleRight = this.find(".anchor.middle-right");
            this.anchorMiddleBottom = this.find(".anchor.middle-bottom");
            this.anchorMiddleTop = this.find(".anchor.middle-top");
        }

        //if (fx.browser.isMobile && !fx.browser.isTablet)
        if (!this.options.rotate)
            fx.dom.css(this.anchorRotate, {display : "none"});

        if (!this.options.anchors)
        {
            fx.dom.css(this.anchorTopLeft, {display : "none"});
            fx.dom.css(this.anchorTopRight, {display : "none"});
            fx.dom.css(this.anchorBottomRight, {display : "none"});
            fx.dom.css(this.anchorBottomLeft, {display : "none"});
            fx.dom.css(this.anchorMiddleLeft, {display : "none"});
            fx.dom.css(this.anchorMiddleRight, {display : "none"});
            fx.dom.css(this.anchorMiddleBottom, {display : "none"});
            fx.dom.css(this.anchorMiddleTop, {display : "none"});
        }
    

        if (this.options.innerDrag)
            this.innerDrag = this.find(".drag");

        this.borderContainer = this.find(".border");

        this.on("mousedown", this._onMouseDown, this.borderContainer);

        this.addClass("anchorsVisible");
    }

    _onMouseDown(e)
    {
        this._anchorDown = fx.dom.parent(e.target, ".anchor");

        if (this._anchorDown)
            fx.dom.addClass(this._anchorDown, "down");

        this.on("mouseup", this._onMouseUp, window);
    }

    _onMouseUp()
    {
        if (this._anchorDown)
            fx.dom.removeClass(this._anchorDown, "down");
    }


    onMouseMove(e)
    {
        if (!this.currentElement || !this.currentElement.data || this._action)
            return;

        let position = fx.dom.offset(this.borderContainer);

        let over = fx.dom.parent(e.target, ".anchor") ||
                    (e.pageX >= position.left && e.pageX <= position.left + (this.currentElement.width * this.scale * this.model.zoom.realValue) &&
                    e.pageY >= position.top && e.pageY <= position.top + (this.currentElement.height * this.scale * this.model.zoom.realValue) );

        if (over)
        {
            this._hideHanchorsCalled = false;
            //this.delay(this._hideHanchors, null);
            this._showAnchors();
        }
        else
        {
            if (!this._hideHanchorsCalled)
            {
                this._hideHanchorsCalled = true;            
                //this.delay(this._hideHanchors, 250);
                this._hideHanchors();
            }
        }
            

    }


    show()
    {
        super.show();
        
        //this.delay(this._hideHanchors, null);
        this._showAnchors();
    }

    hide()
    {
        super.hide();
    }

    _showAnchors()
    {
        if (!this.currentElement || !this.currentElement.editable)
        {
            this._hideHanchors();
            return;
        }

        if (this.currentElement)
        {
            if (this.options.innerDrag)
            {
                if(this.currentElement.innerDragEnabled && !this.currentElement.empty)
                    fx.dom.addClass(this.innerDrag, "visible");
                else
                    fx.dom.removeClass(this.innerDrag, "visible");
            }
        }

        this._anchorsVisible = true;
    }

    _hideHanchors()
    {
         if(this.currentElement && this.currentElement.innerDragEnabled && this.options.innerDrag)
            fx.dom.removeClass(this.innerDrag, "visible");
        this._anchorsVisible = false;
        this._hideHanchorsCalled = false;
    }

    position(e)
    {
        super.position(e);
        if(this.currentElement && this.currentElement.hoverable)
        {
            if (this.options.anchors)
            {
                fx.dom.addClass(this.anchorRotate, "hide");
                fx.dom.addClass(this.anchorTopLeft, "hide");
                fx.dom.addClass(this.anchorTopRight, "hide");
                fx.dom.addClass(this.anchorBottomRight, "hide");
                fx.dom.addClass(this.anchorBottomLeft, "hide");
                fx.dom.addClass(this.anchorMiddleLeft, "hide");
                fx.dom.addClass(this.anchorMiddleRight, "hide");
                fx.dom.addClass(this.anchorMiddleBottom, "hide");
                fx.dom.addClass(this.anchorMiddleTop, "hide");
                this._hideHanchors();
            }
        }
        if (this.currentElement && this.currentElement.data && typeof this.currentElement == "object" && typeof this.currentArea == "object" && this.currentElement.selectable)
        {
            let width = this.currentElement.width;
            let height = this.currentElement.height;

            if (this.options.anchors)
            {
                this.css(this.anchorTopLeft, {
                                            top:-(fx.dom.outerHeight(this.anchorTopLeft)/2 ), 
                                            left:-(fx.dom.outerWidth(this.anchorTopLeft)/2 ),
                                            transform : 'scale(' +  (1 / this.scale) + ')'
                                            //width : size, 
                                            //height : size
                                        });

                this.css(this.anchorTopRight, {
                                            top:-(fx.dom.outerHeight(this.anchorTopRight)/2 ), 
                                            left:width-(fx.dom.outerWidth(this.anchorTopRight)/2 ),
                                            transform : 'scale(' +  (1 / this.scale) + ')'
                                            //width : size, 
                                            //height : size
                                        });

                this.css(this.anchorBottomRight, {
                                                top:height - (fx.dom.outerHeight(this.anchorBottomRight)/2 ), 
                                                left:width-(fx.dom.outerWidth(this.anchorBottomRight)/2 ),
                                                transform : 'scale(' +  (1 / this.scale) + ')'
                                                //width : size, 
                                                //height : size
                                            });

                this.css(this.anchorBottomLeft, {
                                                top:height - (fx.dom.outerHeight(this.anchorBottomLeft)/2 ), 
                                                left:-(fx.dom.outerWidth(this.anchorBottomLeft) )/2,
                                                transform : 'scale(' +  (1 / this.scale) + ')'
                                                //width : size, 
                                                //height : size
                                            });

                this.css(this.anchorMiddleLeft, {
                                                top:(height - (fx.dom.outerHeight(this.anchorMiddleLeft))) / 2, 
                                                left:-(fx.dom.outerWidth(this.anchorMiddleLeft)/2 ) - 2/this.scale,
                                                transform : 'scale(' +  (1 / this.scale) + ')'
                                                //width : size, 
                                                //height : size
                                            });

                this.css(this.anchorMiddleRight, {
                                                top:(height - (fx.dom.outerHeight(this.anchorMiddleRight) )) / 2, 
                                                left:width-(fx.dom.outerWidth(this.anchorMiddleRight) )/2 + 2/this.scale,
                                                transform : 'scale(' +  (1 / this.scale) + ')'
                                                //width : size, 
                                                //height : size
                                            });

                this.css(this.anchorMiddleBottom, {
                                                    top:height - (fx.dom.outerHeight(this.anchorMiddleBottom) )/2 + 2/this.scale, 
                                                    left:(width - (fx.dom.outerWidth(this.anchorMiddleBottom) )) / 2,
                                                    transform : 'scale(' +  (1 / this.scale) + ')'
                                                    //width : size, 
                                                    //height : size
                                                });

                this.css(this.anchorMiddleTop, {
                                                top:-(fx.dom.outerHeight(this.anchorMiddleTop) )/2 - 2/this.scale, 
                                                left:(width - (fx.dom.outerWidth(this.anchorMiddleTop) )) / 2,
                                                transform : 'scale(' +  (1 / this.scale) + ')'
                                                //width : size, 
                                                //height : size
                                            });
            }

            if (this.options.innerDrag)
                this.css(this.innerDrag, {
                                            top: (height - fx.dom.outerHeight(this.innerDrag) ) /2, 
                                            left:(width - fx.dom.outerWidth(this.innerDrag)) / 2,
                                            transform : 'scale(' +  (1 / this.scale) + ')'
                                            //width : size, 
                                            //height : size
                                        });


            if (this.options.rotate)
            {
                let angle = Math.abs(this.currentElement.rotation);
                let rotating = e && e.type == "updated" && e.action && e.action.tag == "rotate";

                if (!rotating)
                {
                    if ((angle >= 270 && angle < 360) || (angle >= 0 && angle < 90))
                    {
                        this.css(this.anchorRotate, {'transform' : 'scale(' + (1/this.scale) + ')'} );
                        this.css(this.anchorRotate, {top: - (fx.dom.outerHeight(this.anchorRotate) / this.scale ), left: (width - fx.dom.outerWidth(this.anchorRotate) / this.scale ) / 2});
                        this.removeClass(this.anchorRotate, "bottom");
                    }
                    else
                    {
                        this.css(this.anchorRotate, {'transform' : 'rotate(180deg) scale(' +  (1/this.scale) + ')' });
                        this.css(this.anchorRotate, {top :  height + fx.dom.outerHeight(this.anchorRotate)/ this.scale, left: (width - fx.dom.outerWidth(this.anchorRotate) / this.scale ) / 2  + fx.dom.outerWidth(this.anchorRotate) / this.scale});
                        this.addClass(this.anchorRotate, "bottom");
                    }
                }
            }

            if ( e && e.type == "updated" && e.action && (e.action.tag == "rotate" || e.action.tag == "move" || e.action.tag == "resize"))
            {
                this._action = e.action.tag;

                if (this.options.rotate)
                {
                    if ( !fx.dom.hasClass(this.anchorRotate, "animate") )
                        fx.dom.addClass(this.anchorRotate, "animate");

                    if( e.action.tag != "rotate")
                        fx.dom.addClass(this.anchorRotate, "hide");
                }

                if (this.options.anchors)
                {
                    fx.dom.addClass(this.anchorTopLeft, "hide");
                    fx.dom.addClass(this.anchorTopRight, "hide");
                    fx.dom.addClass(this.anchorBottomRight, "hide");
                    fx.dom.addClass(this.anchorBottomLeft, "hide");
                    fx.dom.addClass(this.anchorMiddleLeft, "hide");
                    fx.dom.addClass(this.anchorMiddleRight, "hide");
                    fx.dom.addClass(this.anchorMiddleBottom, "hide");
                    fx.dom.addClass(this.anchorMiddleTop, "hide");
                }

                this._anchorsHidden = true;

                if (this.currentElement)
                    this.currentElement.anchorsActive = false;

                if (e.action && e.action.data)
                    fx.dom.removeClass(e.action.data.anchor, "hide");

                if( e.action.tag == "resize" || e.action.tag == "rotate")
                {
                    if (this.options.infoBubble)
                    {
                        this.infoBubble.data = this.currentElement.data;
                        this.infoBubble.info = e.action.tag;
                        this.infoBubble.show();
                    }
                }
            } 
            else
            if (this.currentElement.editable)
            {
                this._action = "";

                if (!this.currentElement.aspectratio)
                {
                    if (this.options.anchors)
                    {
                        fx.dom.addClass(this.anchorMiddleLeft, "hide");
                        fx.dom.addClass(this.anchorMiddleRight, "hide");
                        fx.dom.addClass(this.anchorMiddleBottom, "hide");
                        fx.dom.addClass(this.anchorMiddleTop, "hide");
                        fx.dom.addClass(this.anchorRotate, "hide");

                        if (!this.currentElement.resizable)
                        {
                            fx.dom.addClass(this.anchorTopLeft, "hide");
                            fx.dom.addClass(this.anchorTopRight, "hide");
                            fx.dom.addClass(this.anchorBottomRight, "hide");
                            fx.dom.addClass(this.anchorBottomLeft, "hide");
                        }
                        else
                        {
                            fx.dom.removeClass(this.anchorTopLeft, "hide");
                            fx.dom.removeClass(this.anchorTopRight, "hide");
                            fx.dom.removeClass(this.anchorBottomRight, "hide");
                            fx.dom.removeClass(this.anchorBottomLeft, "hide");
                        }
                    }
                }
                else
                if (!this.currentElement.resizable)
                {
                    if (this.options.anchors)
                    {
                        fx.dom.addClass(this.anchorMiddleLeft, "hide");
                        fx.dom.addClass(this.anchorMiddleRight, "hide");
                        fx.dom.addClass(this.anchorMiddleBottom, "hide");
                        fx.dom.addClass(this.anchorMiddleTop, "hide");
                        fx.dom.addClass(this.anchorRotate, "hide");

                        fx.dom.addClass(this.anchorTopLeft, "hide");
                        fx.dom.addClass(this.anchorTopRight, "hide");
                        fx.dom.addClass(this.anchorBottomRight, "hide");
                        fx.dom.addClass(this.anchorBottomLeft, "hide");
                    }
                }
                else
                {
                    if (this.options.rotate)
                        fx.dom.removeClass(this.anchorRotate, "hide");

                    this.delay(this._finishAnimate);
                    
                
                    if (width > 20 && height > 20)
                    {
                        if (this.options.anchors)
                        {
                            fx.dom.removeClass(this.anchorTopLeft, "hide");
                            fx.dom.removeClass(this.anchorTopRight, "hide");
                            fx.dom.removeClass(this.anchorBottomRight, "hide");
                            fx.dom.removeClass(this.anchorBottomLeft, "hide");
                        }
                    }

                    if (this.options.anchors)
                    {
                        fx.dom.removeClass(this.anchorMiddleLeft, "hide");
                        fx.dom.removeClass(this.anchorMiddleRight, "hide");
                        fx.dom.removeClass(this.anchorMiddleBottom, "hide");
                        fx.dom.removeClass(this.anchorMiddleTop, "hide");
                    }

                    this._anchorsHidden = false;
                }

                if (this.currentElement)
                    this.currentElement.anchorsActive = true;
            
                this.infoBubble.hide();    
            }

            if ((this.currentElement.rotation >= 0 && this.currentElement.rotation <= 22.5) ||
                (this.currentElement.rotation >= 337.5 && this.currentElement.rotation <= 360) )
            {
                if (this.options.anchors)
                {
                    fx.dom.css(this.anchorTopLeft, {"cursor" : "nwse-resize"});
                    fx.dom.css(this.anchorTopRight, {"cursor" : "nesw-resize"});
                    fx.dom.css(this.anchorBottomRight, {"cursor" : "nwse-resize"});
                    fx.dom.css(this.anchorBottomLeft, {"cursor" : "nesw-resize"});
                    fx.dom.css(this.anchorMiddleLeft, {"cursor" : "ew-resize"});
                    fx.dom.css(this.anchorMiddleRight, {"cursor" : "ew-resize"});
                    fx.dom.css(this.anchorMiddleBottom, {"cursor" : "ns-resize"});
                    fx.dom.css(this.anchorMiddleTop, {"cursor" : "ns-resize"});
                }
            }
            else
            if (this.currentElement.rotation >= 22.5 && this.currentElement.rotation <= 67.5)
            {
                if (this.options.anchors)
                {
                    fx.dom.css(this.anchorTopLeft, {"cursor" : "ns-resize"});
                    fx.dom.css(this.anchorTopRight, {"cursor" : "ew-resize"});
                    fx.dom.css(this.anchorBottomRight, {"cursor" : "ns-resize"});
                    fx.dom.css(this.anchorBottomLeft, {"cursor" : "ew-resize"});
                    fx.dom.css(this.anchorMiddleLeft, {"cursor" : "nwse-resize"});
                    fx.dom.css(this.anchorMiddleRight, {"cursor" : "nwse-resize"});
                    fx.dom.css(this.anchorMiddleBottom, {"cursor" : "nesw-resize"});
                    fx.dom.css(this.anchorMiddleTop, {"cursor" : "nesw-resize"});
                }
            }
            else
            if (this.currentElement.rotation >= 67.5 && this.currentElement.rotation <= 112.5)
            {
                if (this.options.anchors)
                {
                    fx.dom.css(this.anchorTopLeft, {"cursor" : "nesw-resize"});
                    fx.dom.css(this.anchorTopRight, {"cursor" : "nwse-resize"});
                    fx.dom.css(this.anchorBottomRight, {"cursor" : "nesw-resize"});
                    fx.dom.css(this.anchorBottomLeft, {"cursor" : "nwse-resize"});
                    fx.dom.css(this.anchorMiddleLeft, {"cursor" : "ns-resize"});
                    fx.dom.css(this.anchorMiddleRight, {"cursor" : "ns-resize"});
                    fx.dom.css(this.anchorMiddleBottom, {"cursor" : "ew-resize"});
                    fx.dom.css(this.anchorMiddleTop, {"cursor" : "ew-resize"});
                }
            }
            else
            if (this.currentElement.rotation >= 112.5 && this.currentElement.rotation <= 157.5)
            {
                if (this.options.anchors)
                {
                    fx.dom.css(this.anchorTopLeft, {"cursor" : "ew-resize"});
                    fx.dom.css(this.anchorTopRight, {"cursor" : "ns-resize"});
                    fx.dom.css(this.anchorBottomRight, {"cursor" : "ew-resize"});
                    fx.dom.css(this.anchorBottomLeft, {"cursor" : "ns-resize"});
                    fx.dom.css(this.anchorMiddleLeft, {"cursor" : "nesw-resize"});
                    fx.dom.css(this.anchorMiddleRight, {"cursor" : "nesw-resize"});
                    fx.dom.css(this.anchorMiddleBottom, {"cursor" : "nwse-resize"});
                    fx.dom.css(this.anchorMiddleTop, {"cursor" : "nwse-resize"});
                }
            }
            else
            if (this.currentElement.rotation >= 157.5 && this.currentElement.rotation <= 202.5)
            {
                if (this.options.anchors)
                {
                    fx.dom.css(this.anchorTopLeft, {"cursor" : "nwse-resize"});
                    fx.dom.css(this.anchorTopRight, {"cursor" : "nesw-resize"});
                    fx.dom.css(this.anchorBottomRight, {"cursor" : "nwse-resize"});
                    fx.dom.css(this.anchorBottomLeft, {"cursor" : "nesw-resize"});
                    fx.dom.css(this.anchorMiddleLeft, {"cursor" : "ew-resize"});
                    fx.dom.css(this.anchorMiddleRight, {"cursor" : "ew-resize"});
                    fx.dom.css(this.anchorMiddleBottom, {"cursor" : "ns-resize"});
                    fx.dom.css(this.anchorMiddleTop, {"cursor" : "ns-resize"});
                }
            }
            else
            if (this.currentElement.rotation >= 202.5 && this.currentElement.rotation <= 247.5)
            {
                if (this.options.anchors)
                {
                    fx.dom.css(this.anchorTopLeft, {"cursor" : "ns-resize"});
                    fx.dom.css(this.anchorTopRight, {"cursor" : "ew-resize"});
                    fx.dom.css(this.anchorBottomRight, {"cursor" : "ns-resize"});
                    fx.dom.css(this.anchorBottomLeft, {"cursor" : "ew-resize"});
                    fx.dom.css(this.anchorMiddleLeft, {"cursor" : "nwse-resize"});
                    fx.dom.css(this.anchorMiddleRight, {"cursor" : "nwse-resize"});
                    fx.dom.css(this.anchorMiddleBottom, {"cursor" : "nesw-resize"});
                    fx.dom.css(this.anchorMiddleTop, {"cursor" : "nesw-resize"});
                }
            }
            else
            if (this.currentElement.rotation >= 292.5 && this.currentElement.rotation <= 337.5)
            {
                if (this.options.anchors)
                {
                    fx.dom.css(this.anchorTopLeft, {"cursor" : "ew-resize"});
                    fx.dom.css(this.anchorTopRight, {"cursor" : "ns-resize"});
                    fx.dom.css(this.anchorBottomRight, {"cursor" : "ew-resize"});
                    fx.dom.css(this.anchorBottomLeft, {"cursor" : "ns-resize"});
                    fx.dom.css(this.anchorMiddleLeft, {"cursor" : "nesw-resize"});
                    fx.dom.css(this.anchorMiddleRight, {"cursor" : "nesw-resize"});
                    fx.dom.css(this.anchorMiddleBottom, {"cursor" : "nwse-resize"});
                    fx.dom.css(this.anchorMiddleTop, {"cursor" : "nwse-resize"});
                }
            }
        
        }

       
        else
        if (!this.currentElement && this.options.infoBubble)
            this.infoBubble.hide();
    }

    _finishAnimate()
    {
        if (this.options.rotate)
            fx.dom.removeClass(this.anchorRotate, "animate")
    }

    render()
    {
        let html = '<div class="border">';

        if (this.options.rotate)
            html += this.assets.rotate.render("anchor rotate");
        //html += '<div class="anchor rotate">' + this.assets.rotate.render("rotate-icon") + '<div class="rotate-anchor"></div><div class="rotate-leg"></div></div>';
        
        if (this.options.anchors)
        {
            //html += this.assets.resizeH.render("anchor resize middle-left anchor-hidden");
            html += '<div class="anchor resize middle-left anchor-hidden"></div>';
            //html += this.assets.resizeH.render("anchor resize middle-right");
            html += '<div class="anchor resize middle-right"></div>';
            //html += this.assets.resizeV.render("anchor resize middle-bottom");
            html += '<div class="anchor resize middle-bottom"></div>';
            //html += this.assets.resizeV.render("anchor resize middle-top anchor-hidden");
            html += '<div class="anchor resize middle-top anchor-hidden"></div>';
            //html += this.assets.resizeDL.render("anchor resize top-left anchor-hidden");
            html += '<div class="anchor resize top-left anchor-hidden"></div>';
            //html += this.assets.resizeDR.render("anchor resize top-right anchor-hidden");
            html += '<div class="anchor resize top-right anchor-hidden"></div>';
            //html += this.assets.resizeDL.render("anchor resize bottom-right");
            html += '<div class="anchor resize bottom-right"></div>';
            //html += this.assets.resizeDR.render("anchor resize bottom-left anchor-hidden");
            html += '<div class="anchor resize bottom-left anchor-hidden"></div>';
        }

        if (this.options.innerDrag)
            html += this.assets.innerDragBtn.render("drag");
        
        html += '</div>';

        return html;
    }
    


    destroy()
    {
        super.destroy();

        if (this._infoBubble)
            this._infoBubble.destroy();
    }

});